import React, {useEffect, useState} from "react";
import { CloudUploadOutlined, DeleteFilled } from "@ant-design/icons";
import { Button, Col, Form, Row, Upload } from "antd";
import { useSelector } from "react-redux";
import { useActiveCompanyData } from "hooks/CompanyHooks";
import YourLogo from "assets/Images/YourLogo.png";

import { addCustomerAsset } from "apiService/RESTApi";

// AssetUploader component
export default function AssetUploader({currentIconUrl, hintText, onAssetUploadCallback = (uploadedAssetUrl) => {} }) {

  const { roAdmin } = useSelector((state) => state.loginReducer);
  
  const activeCompanyData = useActiveCompanyData();
  const [uploadedImage, setUploadedImage] = useState(YourLogo);

  useEffect(() => {
    if (currentIconUrl === undefined || currentIconUrl === '') {
      setUploadedImage(YourLogo)
      return;
    }
    setUploadedImage(currentIconUrl);

  }, [currentIconUrl]);

  const uploadFile = async (options) => {
    const uploadedAsset = await addCustomerAsset(activeCompanyData.uuid, options.file);
    options.file = '';

    if (uploadedAsset === undefined || uploadedAsset.url === undefined) {
        return;
    }

    setUploadedImage(uploadedAsset.url);
    onAssetUploadCallback(uploadedAsset.url);
  };

  const deleteLogo = () => {
    setUploadedImage(YourLogo);
    onAssetUploadCallback(YourLogo);
  };

  return (
    <>
      <div className="white-box logo-box" style={{ background: "none" }}>
        <Row gutter={10}>
          <Col
            span={24}
            sm={12}
            md={12}
            lg={24}
            xl={24}
            xxl={12}
            style={{ background: "white", borderRadius: "7px" }}
          >
            <Row gutter={10}>
              <Col span={24}>
                <img
                  src={uploadedImage}
                  style={{
                    margin: "auto",
                    display: "flex",
                    width: "100%",
                    padding: "20px 30px",
                  }}
                  alt="logo"
                />
              </Col>
              <Col span={24}>
                <Row gutter={10}>
                  <Col span={12}>
                    <Button
                      className="standard-button primary-dark-blue-button"
                      icon={<DeleteFilled />}
                      style={{
                        width: "calc(100% - 5px)",
                      }}
                      onClick={() => deleteLogo()}
                      disabled={roAdmin}
                    >
                      Delete
                    </Button>
                  </Col>
                  <Col span={12} style={{ paddingRight: "0px" }}>
                    <Upload
                      customRequest={(e) => uploadFile(e)}
                      accept="image/*"
                    >
                      <Button
                        className="standard-button primary-dark-blue-button"
                        icon={<CloudUploadOutlined />}
                        style={{
                          width: "calc(100% - 5px)",
                        }}
                        disabled={roAdmin}
                      >
                        Upload
                      </Button>
                    </Upload>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <Form>
        <Row>
          <Col span={24}>
            <span style={{ fontStyle: "italic" }}> { hintText } </span>
          </Col>
        </Row>
      </Form>
    </>
  );
}
